import { render, staticRenderFns } from "./PartnerData.vue?vue&type=template&id=4a86f595&scoped=true&"
import script from "./PartnerData.vue?vue&type=script&lang=js&"
export * from "./PartnerData.vue?vue&type=script&lang=js&"
import style0 from "./PartnerData.vue?vue&type=style&index=0&id=4a86f595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86f595",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
